export const config = {
    baseUrl: process.env.VUE_APP_API_URL,
    fakeBackend: false,
    resourceUrl: '/public/images/',
    instagramUrl: 'https://www.instagram.com/accessories.pb/',
    shoppingCartApi: {
        shoppingCart: '/shopping-cart',
        season: '/seasons',
        checkout: '/checkout',
        country: '/public/country'
    },
    sampleApi: {
        sample: '/sample',
        sampleAdmin: '/sample/admin'
    },
    trackingApi: {
        page: '/public/track-page',
        event: '/public/track-event'
    },
    userApi: {
        auth: '/oauth/token',
        logout: '/oauth/revoke',
        user: '/users',
        role: '/roles',
        resource: '/resource',
        session: '/session',
        register: '/public/register',
        registration: '/registration',
        activate: '/public/activate',
        passwordRecovery: '/public/recover-password',
        changePassword: '/change-password',
        emailCheck: '/public/known-email'
    },
    devicePairingApi: {
        create: '/device-pairing/create',
        redeem: '/public/device-pairing/redeem'
    },
    articleApi: {
        category: '/public/category',
        article: '/public/article',
        articleStub: '/private/article/stub',
        cardArticle: '/private/article/card',
        customerArticle: '/private/article',
        customerArticleStub: '/private/article/stub',
        customerCategory: '/private/category',
        categoryFilterList: '/public/category/filter',
        articlePrice: '/private/pricing',
        cards: '/private/card',
    },
    favoriteApi: {
        favorite: '/favorite',

    },
    contactApi: {
        contact: '/contact',
    },
    contentApi: {
        content: 'public/cms/content',
        list: 'public/cms/list',
        template: '/cms/template',
        listAdmin: '/cms/list',
        contentAdmin: '/cms/content'
    },
    employeeApi: {
        employee: '/public/employee'
    },
    cutomerContactApi: {
        contact: '/diamond/contacts'
    },
    fileApi: {
        image: '/private/file/image',
        media: '/private/media'
    },
    mock3d: {
        140533: "https://int.dmix.cloud/objectdetails?uuid=5c56cdf7e4b07f5e5b812cce&type=model",
        127940: "https://int.dmix.cloud/objectdetails?uuid=5c56c04ae4b07f5e5b812be1&type=model",
        124965: "https://int.dmix.cloud/objectdetails?uuid=5c56c04ae4b07f5e5b812be1&type=model",
        128586: "https://int.dmix.cloud/objectdetails?uuid=5dcaa36c0cf24de66f01be69&type=model",
        143587: "https://int.dmix.cloud/objectdetails?uuid=5dcaa4560cf24de66f01be81&type=model",
        145197: "https://int.dmix.cloud/objectdetails?uuid=5dcaa3ed0cf24de66f01be75&type=model",
        141991: "https://int.dmix.cloud/objectdetails?uuid=5dcaa3ed0cf24de66f01be75&type=model"
    }
};